import React from 'react';
import {
  Radio, SelectionControlLabel,
  Typography
} from '@one-thd/sui-atomic-components';
import { getString } from '../../../utils/general';

function addressRadioButton(address, isDisabled) {

  const {
    firstName,
    lastName,
    addressLine1,
    addressLine2,
    city,
    state,
    zip5,
    addressIdentifier
  } = address;

  const namePart = `${getString(firstName)} ${getString(lastName)}`;
  const addressPart1 = addressLine1 + ((addressLine2 && addressLine2 !== 'undefined') ? ` ${addressLine2}` : '');

  let addressText = [addressPart1, city, state].join(', ') + ' ' + zip5;
  if (getString(namePart).length > 0) {
    addressText = namePart + ', ' + addressText;
  }

  return (
    <div key={addressIdentifier} className="sui-p-1">
      <SelectionControlLabel label={addressText}>
        <Radio disabled={isDisabled} value={`${addressIdentifier}`} />
      </SelectionControlLabel>
    </div>
  );
}

function AddressBox(address) {
  return addressRadioButton(address, false);
}

function DisabledAddressBox(address) {
  return addressRadioButton(address, true);
}

export {
  AddressBox,
  DisabledAddressBox
};
